import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import { Router } from 'react-router-dom';
import App from './app';
import registerServiceWorker from './registerServiceWorker';
import store from './store/configureStore';
import {Route} from 'react-router-dom';
import history from './memoryHistory';

// window['api_url'] = loc

ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>        
        <Route path="/" component={App} />   
      </Router>
    </Provider>,
    document.getElementById('root')
  )
 
//registerServiceWorker();

